module.exports = __webpack_public_path__ + "static/media/md-rocket.bf5d2a06.svg";